export default "__VITE_ASSET__Cyb10TA7__"